// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1AxbY","main-wrapper":"App_main-wrapper__3N0ch"};